namespace Matrix.Data {
    export interface ModelTargetDeleteRequest extends Serenity.DeleteRequest {
        ConfirmDelete?: boolean;
    }
}
